import {NgModule} from '@angular/core';
import {MaxDirective} from './validator/max-validator/max.directive';
import {MinDirective} from './validator/min-validator/min.directive';
import {DurationDirective} from './validator/duration-validator/duration-validator.directive';

@NgModule({
    declarations: [
        DurationDirective,
        MaxDirective,
        MinDirective
    ],
    exports: [
        DurationDirective,
        MaxDirective,
        MinDirective
    ]
})
export class ValidatorsModule {
}
